<template>
  <v-row>
    <v-col cols="12">
      <Filtro/>
    </v-col>
    <v-col cols="12">
      <TableAdimplencia/>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Adimplencia',

  components: {
    Filtro: () => import("./components/Filtro"),
    TableAdimplencia: () => import("./components/TableAdimplencia")
  }
}
</script>